"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("users").controller("UsersCtrl", Ctrl);

  function Ctrl($rootScope, $scope, $controller, ModalService, $confirm, AgGridService, ModelsService, GroupsService, VehiclesService, CustomersService, CustomListsService, UsersService, TelematicsService, TelematicSyncConfigsService, SyncConfigsService) {
    var _this = this;

    var vm = this;

    vm.ctrlName = "UsersCtrl";

    vm.tutoIsActived = true;

    $controller("UsersCtrl.bulk", {
      vm: vm
    });

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: UsersService,
      params: {
        editPage: "users/user"
      }
    });

    vm.activeTab = "actifs";

    vm.defaultManagerLabel = $rootScope.defaultManagerLabel;
    vm.qseManagerLabel = $rootScope.qseManagerLabel;
    vm.rhManagerLabel = $rootScope.rhManagerLabel;
    vm.fleetManagerLabel = $rootScope.fleetManagerLabel;
    vm.other1ManagerLabel = $rootScope.other1ManagerLabel;
    vm.other2ManagerLabel = $rootScope.other2ManagerLabel;

    vm.qseManagerHidden = $rootScope.qseManagerHidden;
    vm.rhManagerHidden = $rootScope.rhManagerHidden;
    vm.fleetManagerHidden = $rootScope.fleetManagerHidden;
    vm.other1ManagerHidden = $rootScope.other1ManagerHidden;
    vm.other2ManagerHidden = $rootScope.other2ManagerHidden;

    vm.smartTablePageSize = ModelsService.nbTableLine ? ModelsService.nbTableLine : 5;

    setTimeout(function () {
      ModelsService.onCustomerChange(vm.refresh, true);
      ModelsService.hotkeys($scope, "+", "Créer un nouveau collaborateur", vm.create);
    }, 0);

    vm.displayInfo = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UsersService.displayInfo(user, vm.isAdmin, vm.isLvr, vm.isSuperAdmin, vm.syncConfig, vm.telematicSyncConfig, vm.softwareName);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.openActionHistory = function () {
      ModalService.openComponent("action-histories", { size: "lg" }).then(function () {
        vm.refresh();
        console.log("close modal");
      }).catch(function (err) {
        console.log("err", err);
      });
    };

    vm.refresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
        var roles, promises;
        return regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if ($rootScope.$selectedCustomerId) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return TelematicSyncConfigsService.findOne({
                  filter: {
                    where: {
                      customerId: $rootScope.$selectedCustomerId.replace("$", "")
                    },
                    fields: { software: true, fields: true }
                  }
                });

              case 4:
                vm.telematicSyncConfig = _context4.sent;

                if (!(vm.telematicSyncConfig && vm.telematicSyncConfig.software)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 8;
                return CustomListsService.getNameByValue("telematicSoftware", vm.telematicSyncConfig.software);

              case 8:
                vm.softwareName = _context4.sent;

              case 9:
                _context4.next = 11;
                return SyncConfigsService.findOne({
                  filter: {
                    where: {
                      customerId: $rootScope.$selectedCustomerId.replace("$", "")
                    },
                    fields: { software: true }
                  }
                });

              case 11:
                vm.syncConfig = _context4.sent;


                vm.setGridColumns();

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                vm.actionChange(); // refresh

                _context4.prev = 15;
                _context4.next = 18;
                return CustomListsService.getSelectArray("roles");

              case 18:
                roles = _context4.sent;
                _context4.next = 21;
                return vm.getRightsFields();

              case 21:
                vm.rightsFields = _context4.sent;


                vm.rowsSelected = [];

                promises = [UsersService.load(["lastName", // lastName en 1er car ça permet de trier par nom de famille
                "firstName", "internalNumber", "_id", "customerId", "trueInternalNumber", "email", "cellularPhone", "phone", "defaultManagerId", "rhManagerId", "qseManagerId", "fleetManagerId", "other1ManagerId", "other2ManagerId", "defaultManagerIdIsAutoFilled", "rhManagerIdIsAutoFilled", "qseManagerIdIsAutoFilled", "fleetManagerIdIsAutoFilled", "other1ManagerIdIsAutoFilled", "other2ManagerIdIsAutoFilled", "groupsId", "usersEmailsCcId", "typeVehicles", "contract", "yearOfBirth", "startDate", "endDate", "endBlockDate", "creationDate", "lastUserModificationDate", "importDate", "importBy", "updateDate", "updateBy", "active", "positions", "positionTitle", "areaName", "departmentName", "licenceValidityDate", "role", "rights", "onlyMerchandise", "canLoginToBeta", "isVirtual", "isVisibleByEveryone", "toCheck", "externalCompany", "nbElearnings.short", "nbElearnings.long", "nbDamages", "nbAccidents", "nbMissingDepas", "nbDepas", "nbCourses", "lastDamageDate", "lastDepaDate", "lastCourseDate", "nbDispute0", "nbDispute50", "nbDispute100", "note", "creationUserId", "isServiceAccount"], true, null), VehiclesService.load(["_id", "plateNumber", "_driverIds"])];
                _context4.next = 26;
                return Promise.all(promises).then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
                    var users, vehicles, vehicleMap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, vehicle, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, driverId, duplicateEmails, duplicateCellularPhones, duplicateInternalNumbers, pages, actions, telematics, telematicsMap, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, telematic, _loop, index;

                    return regeneratorRuntime.wrap(function _callee2$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            users = data[0];
                            vehicles = data[1];
                            vehicleMap = {};
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context3.prev = 6;
                            _iterator = vehicles[Symbol.iterator]();

                          case 8:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                              _context3.next = 34;
                              break;
                            }

                            vehicle = _step.value;

                            if (vehicle._driverIds) {
                              _context3.next = 12;
                              break;
                            }

                            return _context3.abrupt("continue", 31);

                          case 12:
                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context3.prev = 15;

                            for (_iterator3 = vehicle._driverIds[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                              driverId = _step3.value;

                              if (!vehicleMap[driverId]) {
                                vehicleMap[driverId] = [];
                              }
                              vehicleMap[driverId].push(vehicle.plateNumber);
                            }
                            _context3.next = 23;
                            break;

                          case 19:
                            _context3.prev = 19;
                            _context3.t0 = _context3["catch"](15);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context3.t0;

                          case 23:
                            _context3.prev = 23;
                            _context3.prev = 24;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                              _iterator3.return();
                            }

                          case 26:
                            _context3.prev = 26;

                            if (!_didIteratorError3) {
                              _context3.next = 29;
                              break;
                            }

                            throw _iteratorError3;

                          case 29:
                            return _context3.finish(26);

                          case 30:
                            return _context3.finish(23);

                          case 31:
                            _iteratorNormalCompletion = true;
                            _context3.next = 8;
                            break;

                          case 34:
                            _context3.next = 40;
                            break;

                          case 36:
                            _context3.prev = 36;
                            _context3.t1 = _context3["catch"](6);
                            _didIteratorError = true;
                            _iteratorError = _context3.t1;

                          case 40:
                            _context3.prev = 40;
                            _context3.prev = 41;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }

                          case 43:
                            _context3.prev = 43;

                            if (!_didIteratorError) {
                              _context3.next = 46;
                              break;
                            }

                            throw _iteratorError;

                          case 46:
                            return _context3.finish(43);

                          case 47:
                            return _context3.finish(40);

                          case 48:

                            vm.rawData = [];
                            vm.rawActive = [];
                            vm.rawDuplicate = [];
                            vm.rawToCheck = [];
                            vm.rawCommute = [];

                            duplicateEmails = {};
                            duplicateCellularPhones = {};
                            duplicateInternalNumbers = {};
                            pages = ["depa", "damage", "course", "resource"];
                            actions = ["read", "write", "send", "delete"];
                            _context3.next = 60;
                            return TelematicsService.find({
                              filter: {
                                where: {
                                  _customerId: $rootScope.$selectedCustomerId.replace("$", ""),
                                  from: {
                                    $gte: moment().startOf("month").subtract(3, "month").toDate(),
                                    $lte: moment().toDate()
                                  }
                                },
                                fields: {
                                  _id: 1,
                                  from: 1,
                                  to: 1,
                                  globalScore: 1,
                                  _driverId: 1,
                                  distanceTotal: 1,
                                  durationTotal: 1,
                                  fuelUsage: 1,
                                  constantSpeedScore: 1,
                                  drivingEventsScore: 1,
                                  idlingScore: 1,
                                  fuelUsageScore: 1,
                                  coastingScore: 1,
                                  greenSpeedScore: 1,
                                  highRevvingScore: 1,
                                  overSpeedScore: 1,
                                  rolloutScore: 1,
                                  wastedEnergyScore: 1,
                                  harshBrakingScore: 1
                                },
                                order: { from: 1 }
                              }
                            });

                          case 60:
                            telematics = _context3.sent;
                            telematicsMap = null;

                            if (!(telematics && telematics.length > 0)) {
                              _context3.next = 83;
                              break;
                            }

                            telematicsMap = {};
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context3.prev = 67;
                            for (_iterator2 = telematics[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                              telematic = _step2.value;

                              if (!telematicsMap[telematic._driverId]) {
                                telematicsMap[telematic._driverId] = [];
                              }
                              telematicsMap[telematic._driverId].push({
                                date: moment(telematic.from).format("-YY-MM"),
                                globalScore: typeof telematic.globalScore === "number" ? Math.round(telematic.globalScore * 1000) / 100 : null,
                                constantSpeedScore: typeof telematic.constantSpeedScore === "number" ? Math.round(telematic.constantSpeedScore * 1000) / 100 : null,
                                drivingEventsScore: typeof telematic.drivingEventsScore === "number" ? Math.round(telematic.drivingEventsScore * 1000) / 100 : null,
                                greenSpeedScore: typeof telematic.greenSpeedScore === "number" ? Math.round(telematic.greenSpeedScore * 1000) / 100 : null,
                                highRevvingScore: typeof telematic.highRevvingScore === "number" ? Math.round(telematic.highRevvingScore * 1000) / 100 : null,
                                overSpeedScore: typeof telematic.overSpeedScore === "number" ? Math.round(telematic.overSpeedScore * 1000) / 100 : null,
                                rolloutScore: typeof telematic.rolloutScore === "number" ? Math.round(telematic.rolloutScore * 1000) / 100 : null,
                                wastedEnergyScore: typeof telematic.wastedEnergyScore === "number" ? Math.round(telematic.wastedEnergyScore * 1000) / 100 : null,
                                harshBrakingScore: typeof telematic.harshBrakingScore === "number" ? Math.round(telematic.harshBrakingScore * 1000) / 100 : null,
                                idlingScore: typeof telematic.idlingScore === "number" ? Math.round(telematic.idlingScore * 1000) / 100 : null,
                                fuelUsageScore: typeof telematic.fuelUsageScore === "number" ? Math.round(telematic.fuelUsageScore * 1000) / 100 : null,
                                coastingScore: typeof telematic.coastingScore === "number" ? Math.round(telematic.coastingScore * 1000) / 100 : null,
                                distanceTotal: typeof telematic.distanceTotal === "number" ? telematic.distanceTotal / 1000 : null,
                                fuelUsagePer100Km: telematic.distanceTotal && typeof telematic.fuelUsage === "number" ? Math.round(telematic.fuelUsage / 1000 / (telematic.distanceTotal / 1000) * 100 * 100) / 100 : null
                              });
                            }
                            _context3.next = 75;
                            break;

                          case 71:
                            _context3.prev = 71;
                            _context3.t2 = _context3["catch"](67);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context3.t2;

                          case 75:
                            _context3.prev = 75;
                            _context3.prev = 76;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                              _iterator2.return();
                            }

                          case 78:
                            _context3.prev = 78;

                            if (!_didIteratorError2) {
                              _context3.next = 81;
                              break;
                            }

                            throw _iteratorError2;

                          case 81:
                            return _context3.finish(78);

                          case 82:
                            return _context3.finish(75);

                          case 83:
                            _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                              var user, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _telematic, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, key, vehicles, roleItem, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, page, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, action, customerData, typeVehicles, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _loop2, _iterator7, _step7, usersEmailCc, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _id, name, blocked, previousUserId, previousRow, _previousUserId, _previousRow, _previousUserId2, _previousRow2, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, groupId;

                              return regeneratorRuntime.wrap(function _loop$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      user = users[index];

                                      if (!(telematicsMap && telematicsMap[user._id])) {
                                        _context2.next = 46;
                                        break;
                                      }

                                      user.withTelematic = true;
                                      _iteratorNormalCompletion4 = true;
                                      _didIteratorError4 = false;
                                      _iteratorError4 = undefined;
                                      _context2.prev = 6;
                                      _iterator4 = telematicsMap[user._id][Symbol.iterator]();

                                    case 8:
                                      if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                        _context2.next = 32;
                                        break;
                                      }

                                      _telematic = _step4.value;
                                      _iteratorNormalCompletion5 = true;
                                      _didIteratorError5 = false;
                                      _iteratorError5 = undefined;
                                      _context2.prev = 13;

                                      for (_iterator5 = Object.keys(_telematic)[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                        key = _step5.value;

                                        user[key + "Telematic" + _telematic.date] = _telematic[key];
                                      }
                                      _context2.next = 21;
                                      break;

                                    case 17:
                                      _context2.prev = 17;
                                      _context2.t0 = _context2["catch"](13);
                                      _didIteratorError5 = true;
                                      _iteratorError5 = _context2.t0;

                                    case 21:
                                      _context2.prev = 21;
                                      _context2.prev = 22;

                                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                      }

                                    case 24:
                                      _context2.prev = 24;

                                      if (!_didIteratorError5) {
                                        _context2.next = 27;
                                        break;
                                      }

                                      throw _iteratorError5;

                                    case 27:
                                      return _context2.finish(24);

                                    case 28:
                                      return _context2.finish(21);

                                    case 29:
                                      _iteratorNormalCompletion4 = true;
                                      _context2.next = 8;
                                      break;

                                    case 32:
                                      _context2.next = 38;
                                      break;

                                    case 34:
                                      _context2.prev = 34;
                                      _context2.t1 = _context2["catch"](6);
                                      _didIteratorError4 = true;
                                      _iteratorError4 = _context2.t1;

                                    case 38:
                                      _context2.prev = 38;
                                      _context2.prev = 39;

                                      if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                      }

                                    case 41:
                                      _context2.prev = 41;

                                      if (!_didIteratorError4) {
                                        _context2.next = 44;
                                        break;
                                      }

                                      throw _iteratorError4;

                                    case 44:
                                      return _context2.finish(41);

                                    case 45:
                                      return _context2.finish(38);

                                    case 46:
                                      vehicles = vehicleMap[user._id] || [];

                                      user.vehicleNames = vehicles.join(", ");

                                      roleItem = roles.find(function (role) {
                                        return role.value === user.role;
                                      });

                                      if (roleItem) {
                                        user.roleName = roleItem.name;
                                      } else {
                                        user.roleName = "";
                                      }

                                      if (user.nbAccidents && user.nbAccidents > 1) {
                                        user.isMulti = true;
                                      } else {
                                        user.isMulti = false;
                                      }

                                      user.shortElearning = user.nbElearnings && user.nbElearnings.short && user.nbElearnings.short.all ? user.nbElearnings.short.done + " / " + user.nbElearnings.short.all : "";

                                      user.longElearning = user.nbElearnings && user.nbElearnings.long && user.nbElearnings.long.all ? user.nbElearnings.long.done + " / " + user.nbElearnings.long.all : "";

                                      if (user.lastDepaDate) {
                                        user.lastDepaInfo = new Date(user.lastDepaDate).toLocaleDateString();
                                      } else if (user.lastDepaId) {
                                        user.lastDepaInfo = "Non effectué";
                                      }

                                      if (!vm.isLvr) {
                                        _context2.next = 73;
                                        break;
                                      }

                                      if (!(user.importBy && user.importBy.startsWith("$"))) {
                                        _context2.next = 61;
                                        break;
                                      }

                                      _context2.next = 58;
                                      return UsersService.getNameById(user.importBy.replace("$", ""));

                                    case 58:
                                      _context2.t2 = _context2.sent;
                                      _context2.next = 62;
                                      break;

                                    case 61:
                                      _context2.t2 = user.importBy;

                                    case 62:
                                      user.importByName = _context2.t2;


                                      if (user.importByName === "?.?" || user.importByName === "Supprimé") {
                                        user.importByName = "LVR";
                                      }

                                      if (!(user.updateBy && user.updateBy.startsWith("$"))) {
                                        _context2.next = 70;
                                        break;
                                      }

                                      _context2.next = 67;
                                      return UsersService.getNameById(user.updateBy.replace("$", ""));

                                    case 67:
                                      _context2.t3 = _context2.sent;
                                      _context2.next = 71;
                                      break;

                                    case 70:
                                      _context2.t3 = user.updateBy;

                                    case 71:
                                      user.updateByName = _context2.t3;


                                      if (user.updateByName === "?.?" || user.updateByName === "Supprimé") {
                                        user.updateByName = "LVR";
                                      }

                                    case 73:

                                      user.btInfo = {
                                        text: '<i class="fa fa-file"></i> Fiche récap.',
                                        color: "custom"
                                      };

                                      user.btEdit = {
                                        text: '<i class="fa fa-edit"></i> Modifier',
                                        color: "custom"
                                      };

                                      user.btDelete = {
                                        text: '<i class="fa fa-trash"></i> Suppr.',
                                        color: "custom-danger"
                                      };

                                      _iteratorNormalCompletion6 = true;
                                      _didIteratorError6 = false;
                                      _iteratorError6 = undefined;
                                      _context2.prev = 79;
                                      _iterator6 = pages[Symbol.iterator]();

                                    case 81:
                                      if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                                        _context2.next = 105;
                                        break;
                                      }

                                      page = _step6.value;
                                      _iteratorNormalCompletion10 = true;
                                      _didIteratorError10 = false;
                                      _iteratorError10 = undefined;
                                      _context2.prev = 86;

                                      for (_iterator10 = actions[Symbol.iterator](); !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                        action = _step10.value;

                                        user["rights" + page.charAt(0).toUpperCase() + page.slice(1) + action.charAt(0).toUpperCase() + action.slice(1)] = "";
                                        if (user.role == "super-admin" || user.role == "user-admin") {
                                          user["rights" + page.charAt(0).toUpperCase() + page.slice(1) + action.charAt(0).toUpperCase() + action.slice(1)] = "X";
                                        } else if (user.rights && user.rights[page]) {
                                          if (user.rights[page][action] == true) {
                                            user["rights" + page.charAt(0).toUpperCase() + page.slice(1) + action.charAt(0).toUpperCase() + action.slice(1)] = "X";
                                          }
                                        }
                                      }
                                      _context2.next = 94;
                                      break;

                                    case 90:
                                      _context2.prev = 90;
                                      _context2.t4 = _context2["catch"](86);
                                      _didIteratorError10 = true;
                                      _iteratorError10 = _context2.t4;

                                    case 94:
                                      _context2.prev = 94;
                                      _context2.prev = 95;

                                      if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                        _iterator10.return();
                                      }

                                    case 97:
                                      _context2.prev = 97;

                                      if (!_didIteratorError10) {
                                        _context2.next = 100;
                                        break;
                                      }

                                      throw _iteratorError10;

                                    case 100:
                                      return _context2.finish(97);

                                    case 101:
                                      return _context2.finish(94);

                                    case 102:
                                      _iteratorNormalCompletion6 = true;
                                      _context2.next = 81;
                                      break;

                                    case 105:
                                      _context2.next = 111;
                                      break;

                                    case 107:
                                      _context2.prev = 107;
                                      _context2.t5 = _context2["catch"](79);
                                      _didIteratorError6 = true;
                                      _iteratorError6 = _context2.t5;

                                    case 111:
                                      _context2.prev = 111;
                                      _context2.prev = 112;

                                      if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                      }

                                    case 114:
                                      _context2.prev = 114;

                                      if (!_didIteratorError6) {
                                        _context2.next = 117;
                                        break;
                                      }

                                      throw _iteratorError6;

                                    case 117:
                                      return _context2.finish(114);

                                    case 118:
                                      return _context2.finish(111);

                                    case 119:
                                      _context2.next = 121;
                                      return CustomersService.getNameById(user.customerId);

                                    case 121:
                                      user.customerName = _context2.sent;
                                      _context2.next = 124;
                                      return CustomersService.getById(user.customerId);

                                    case 124:
                                      customerData = _context2.sent;

                                      user.onlyCommuteTrips = !!(customerData && (customerData.videoOnly === true || customerData.videoOnlyGroupIds && customerData.videoOnlyGroupIds.length > 0 && user.groupsId && user.groupsId.some(function (gId) {
                                        return customerData.videoOnlyGroupIds.includes(gId);
                                      })));

                                      if (!user.contract) {
                                        _context2.next = 132;
                                        break;
                                      }

                                      _context2.next = 129;
                                      return CustomListsService.getNameByValue("typeContract", user.contract);

                                    case 129:
                                      _context2.t6 = _context2.sent;
                                      _context2.next = 133;
                                      break;

                                    case 132:
                                      _context2.t6 = "";

                                    case 133:
                                      user.contractName = _context2.t6;
                                      _context2.next = 136;
                                      return CustomListsService.getSelectArray("typeVehicleV2");

                                    case 136:
                                      typeVehicles = _context2.sent;

                                      typeVehicles = typeVehicles.map(function (item) {
                                        return { value: item.value, name: item.name.split(" (")[0] };
                                      });
                                      user.typeVehicleNames = [];

                                      if (!(user.typeVehicles && user.typeVehicles.length > 0)) {
                                        _context2.next = 160;
                                        break;
                                      }

                                      _iteratorNormalCompletion7 = true;
                                      _didIteratorError7 = false;
                                      _iteratorError7 = undefined;
                                      _context2.prev = 143;

                                      _loop2 = function _loop2() {
                                        var typeVehicle = _step7.value;

                                        var typeVehicleData = typeVehicles.find(function (item) {
                                          return item.value === typeVehicle;
                                        });
                                        if (typeVehicleData && typeVehicleData.name) {
                                          user.typeVehicleNames.push(typeVehicleData.name.split(" (")[0]);
                                        }
                                      };

                                      for (_iterator7 = user.typeVehicles[Symbol.iterator](); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        _loop2();
                                      }
                                      _context2.next = 152;
                                      break;

                                    case 148:
                                      _context2.prev = 148;
                                      _context2.t7 = _context2["catch"](143);
                                      _didIteratorError7 = true;
                                      _iteratorError7 = _context2.t7;

                                    case 152:
                                      _context2.prev = 152;
                                      _context2.prev = 153;

                                      if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                        _iterator7.return();
                                      }

                                    case 155:
                                      _context2.prev = 155;

                                      if (!_didIteratorError7) {
                                        _context2.next = 158;
                                        break;
                                      }

                                      throw _iteratorError7;

                                    case 158:
                                      return _context2.finish(155);

                                    case 159:
                                      return _context2.finish(152);

                                    case 160:
                                      if (!user.other1ManagerId) {
                                        _context2.next = 166;
                                        break;
                                      }

                                      _context2.next = 163;
                                      return UsersService.getNameById(user.other1ManagerId);

                                    case 163:
                                      _context2.t8 = _context2.sent;
                                      _context2.next = 167;
                                      break;

                                    case 166:
                                      _context2.t8 = "";

                                    case 167:
                                      user.other1ManagerName = _context2.t8;

                                      if (!user.other1ManagerId) {
                                        _context2.next = 174;
                                        break;
                                      }

                                      _context2.next = 171;
                                      return UsersService.getNameWithEmailById(user.other1ManagerId);

                                    case 171:
                                      _context2.t9 = _context2.sent;
                                      _context2.next = 175;
                                      break;

                                    case 174:
                                      _context2.t9 = "";

                                    case 175:
                                      user.other1ManagerNameWithEmail = _context2.t9;

                                      if (!user.other2ManagerId) {
                                        _context2.next = 182;
                                        break;
                                      }

                                      _context2.next = 179;
                                      return UsersService.getNameById(user.other2ManagerId);

                                    case 179:
                                      _context2.t10 = _context2.sent;
                                      _context2.next = 183;
                                      break;

                                    case 182:
                                      _context2.t10 = "";

                                    case 183:
                                      user.other2ManagerName = _context2.t10;

                                      if (!user.other2ManagerId) {
                                        _context2.next = 190;
                                        break;
                                      }

                                      _context2.next = 187;
                                      return UsersService.getNameWithEmailById(user.other2ManagerId);

                                    case 187:
                                      _context2.t11 = _context2.sent;
                                      _context2.next = 191;
                                      break;

                                    case 190:
                                      _context2.t11 = "";

                                    case 191:
                                      user.other2ManagerNameWithEmail = _context2.t11;

                                      if (!user.fleetManagerId) {
                                        _context2.next = 198;
                                        break;
                                      }

                                      _context2.next = 195;
                                      return UsersService.getNameById(user.fleetManagerId);

                                    case 195:
                                      _context2.t12 = _context2.sent;
                                      _context2.next = 199;
                                      break;

                                    case 198:
                                      _context2.t12 = "";

                                    case 199:
                                      user.fleetManagerName = _context2.t12;

                                      if (!user.fleetManagerId) {
                                        _context2.next = 206;
                                        break;
                                      }

                                      _context2.next = 203;
                                      return UsersService.getNameWithEmailById(user.fleetManagerId);

                                    case 203:
                                      _context2.t13 = _context2.sent;
                                      _context2.next = 207;
                                      break;

                                    case 206:
                                      _context2.t13 = "";

                                    case 207:
                                      user.fleetManagerNameWithEmail = _context2.t13;

                                      if (!user.rhManagerId) {
                                        _context2.next = 214;
                                        break;
                                      }

                                      _context2.next = 211;
                                      return UsersService.getNameById(user.rhManagerId);

                                    case 211:
                                      _context2.t14 = _context2.sent;
                                      _context2.next = 215;
                                      break;

                                    case 214:
                                      _context2.t14 = "";

                                    case 215:
                                      user.rhManagerName = _context2.t14;

                                      if (!user.rhManagerId) {
                                        _context2.next = 222;
                                        break;
                                      }

                                      _context2.next = 219;
                                      return UsersService.getNameWithEmailById(user.rhManagerId);

                                    case 219:
                                      _context2.t15 = _context2.sent;
                                      _context2.next = 223;
                                      break;

                                    case 222:
                                      _context2.t15 = "";

                                    case 223:
                                      user.rhManagerNameWithEmail = _context2.t15;

                                      if (!user.qseManagerId) {
                                        _context2.next = 230;
                                        break;
                                      }

                                      _context2.next = 227;
                                      return UsersService.getNameById(user.qseManagerId);

                                    case 227:
                                      _context2.t16 = _context2.sent;
                                      _context2.next = 231;
                                      break;

                                    case 230:
                                      _context2.t16 = "";

                                    case 231:
                                      user.qseManagerName = _context2.t16;

                                      if (!user.qseManagerId) {
                                        _context2.next = 238;
                                        break;
                                      }

                                      _context2.next = 235;
                                      return UsersService.getNameWithEmailById(user.qseManagerId);

                                    case 235:
                                      _context2.t17 = _context2.sent;
                                      _context2.next = 239;
                                      break;

                                    case 238:
                                      _context2.t17 = "";

                                    case 239:
                                      user.qseManagerNameWithEmail = _context2.t17;

                                      if (!user.defaultManagerId) {
                                        _context2.next = 246;
                                        break;
                                      }

                                      _context2.next = 243;
                                      return UsersService.getNameById(user.defaultManagerId);

                                    case 243:
                                      _context2.t18 = _context2.sent;
                                      _context2.next = 247;
                                      break;

                                    case 246:
                                      _context2.t18 = "";

                                    case 247:
                                      user.managerName = _context2.t18;

                                      if (!user.defaultManagerId) {
                                        _context2.next = 254;
                                        break;
                                      }

                                      _context2.next = 251;
                                      return UsersService.getNameWithEmailById(user.defaultManagerId);

                                    case 251:
                                      _context2.t19 = _context2.sent;
                                      _context2.next = 255;
                                      break;

                                    case 254:
                                      _context2.t19 = "";

                                    case 255:
                                      user.managerNameWithEmail = _context2.t19;
                                      usersEmailCc = "";

                                      if (!(user.usersEmailsCcId && user.usersEmailsCcId.length > 0)) {
                                        _context2.next = 286;
                                        break;
                                      }

                                      _iteratorNormalCompletion8 = true;
                                      _didIteratorError8 = false;
                                      _iteratorError8 = undefined;
                                      _context2.prev = 261;
                                      _iterator8 = user.usersEmailsCcId[Symbol.iterator]();

                                    case 263:
                                      if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                                        _context2.next = 272;
                                        break;
                                      }

                                      _id = _step8.value;
                                      _context2.next = 267;
                                      return UsersService.getNameById(_id);

                                    case 267:
                                      name = _context2.sent;

                                      usersEmailCc = usersEmailCc + (usersEmailCc ? ", " : "") + name;

                                    case 269:
                                      _iteratorNormalCompletion8 = true;
                                      _context2.next = 263;
                                      break;

                                    case 272:
                                      _context2.next = 278;
                                      break;

                                    case 274:
                                      _context2.prev = 274;
                                      _context2.t20 = _context2["catch"](261);
                                      _didIteratorError8 = true;
                                      _iteratorError8 = _context2.t20;

                                    case 278:
                                      _context2.prev = 278;
                                      _context2.prev = 279;

                                      if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                        _iterator8.return();
                                      }

                                    case 281:
                                      _context2.prev = 281;

                                      if (!_didIteratorError8) {
                                        _context2.next = 284;
                                        break;
                                      }

                                      throw _iteratorError8;

                                    case 284:
                                      return _context2.finish(281);

                                    case 285:
                                      return _context2.finish(278);

                                    case 286:
                                      user.usersEmailCc = usersEmailCc;

                                      if (user.usersEmailCc.includes("Sorti de l'entreprise") || user.other1ManagerName.includes("Sorti de l'entreprise") || user.other2ManagerName.includes("Sorti de l'entreprise") || user.fleetManagerName.includes("Sorti de l'entreprise") || user.rhManagerName.includes("Sorti de l'entreprise") || user.qseManagerName.includes("Sorti de l'entreprise") || user.managerName.includes("Sorti de l'entreprise") || user.usersEmailCc.includes("Supprimé") || user.other1ManagerName.includes("Supprimé") || user.other2ManagerName.includes("Supprimé") || user.fleetManagerName.includes("Supprimé") || user.rhManagerName.includes("Supprimé") || user.qseManagerName.includes("Supprimé") || user.managerName.includes("Supprimé")) {
                                        user.backgroundColor = "rgb(249, 246, 89, 0.5)"; // yellow
                                        // "rgb(249, 105, 89, 0.5)" // red
                                      }

                                      if (user.onlyCommuteTrips) {
                                        user.backgroundColor = "rgb(89, 161, 249, 0.5)"; // bleu clair = appartient à un groupe ayant uniquement accès aux vidéos
                                      }

                                      if (user.isServiceAccount) {
                                        user.backgroundColor = "rgb(161, 89, 249, 0.5)"; // violet = compte de service API
                                      }

                                      blocked = user.endBlockDate && new Date(user.endBlockDate) >= new Date() ? true : false;

                                      user.backgroundColor = blocked ? "rgb(249 89 145 / 50%)" : user.backgroundColor;

                                      user.active = !user.endDate || new Date(user.endDate) >= new Date() ? true : false;
                                      user.backgroundColor = !user.active ? "rgb(249, 161, 89, 0.5)" : user.backgroundColor; // custom-warning 50%

                                      user.duplicate = false;

                                      if (user.active) {
                                        if (user.email && duplicateEmails[user.email]) {
                                          user.duplicate = true;
                                          if (duplicateEmails[user.email].length === 1) {
                                            previousUserId = duplicateEmails[user.email][0];

                                            if (vm.rawDuplicate.filter(function (row) {
                                              return row._id === previousUserId;
                                            }).length === 0) {
                                              previousRow = vm.rawData.find(function (row) {
                                                return row._id === previousUserId;
                                              });

                                              vm.rawDuplicate.push(previousRow);
                                            }
                                          }
                                          duplicateEmails[user.email].push(user._id);
                                        } else if (user.email) {
                                          duplicateEmails[user.email] = [user._id];
                                        }
                                        if (user.cellularPhone && duplicateCellularPhones[user.cellularPhone]) {
                                          user.duplicate = true;
                                          if (duplicateCellularPhones[user.cellularPhone].length === 1) {
                                            _previousUserId = duplicateCellularPhones[user.cellularPhone][0];

                                            if (vm.rawDuplicate.filter(function (row) {
                                              return row._id === _previousUserId;
                                            }).length === 0) {
                                              _previousRow = vm.rawData.find(function (row) {
                                                return row._id === _previousUserId;
                                              });

                                              vm.rawDuplicate.push(_previousRow);
                                            }
                                          }
                                          duplicateCellularPhones[user.cellularPhone].push(user._id);
                                        } else if (user.cellularPhone) {
                                          duplicateCellularPhones[user.cellularPhone] = [user._id];
                                        }
                                        if (user.internalNumber && duplicateInternalNumbers[user.internalNumber]) {
                                          user.duplicate = true;
                                          if (duplicateInternalNumbers[user.internalNumber].length === 1) {
                                            _previousUserId2 = duplicateInternalNumbers[user.internalNumber][0];

                                            if (vm.rawDuplicate.filter(function (row) {
                                              return row._id === _previousUserId2;
                                            }).length === 0) {
                                              _previousRow2 = vm.rawData.find(function (row) {
                                                return row._id === _previousUserId2;
                                              });

                                              vm.rawDuplicate.push(_previousRow2);
                                            }
                                          }
                                          duplicateInternalNumbers[user.internalNumber].push(user._id);
                                        } else if (user.internalNumber) {
                                          duplicateInternalNumbers[user.internalNumber] = [user._id];
                                        }
                                      }

                                      if (!(user.groupsId && user.groupsId.length > 0)) {
                                        _context2.next = 341;
                                        break;
                                      }

                                      if (!(user.groupsId.length == 1)) {
                                        _context2.next = 309;
                                        break;
                                      }

                                      user.groupId = user.groupsId[0];

                                      if (!user.groupId) {
                                        _context2.next = 305;
                                        break;
                                      }

                                      _context2.next = 302;
                                      return GroupsService.getNameById(user.groupId);

                                    case 302:
                                      _context2.t21 = _context2.sent;
                                      _context2.next = 306;
                                      break;

                                    case 305:
                                      _context2.t21 = "";

                                    case 306:
                                      user.groupName = _context2.t21;
                                      _context2.next = 339;
                                      break;

                                    case 309:
                                      if (!(user.groupsId.length > 1)) {
                                        _context2.next = 339;
                                        break;
                                      }

                                      user.groupName = "";

                                      _iteratorNormalCompletion9 = true;
                                      _didIteratorError9 = false;
                                      _iteratorError9 = undefined;
                                      _context2.prev = 314;
                                      _iterator9 = user.groupsId[Symbol.iterator]();

                                    case 316:
                                      if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                                        _context2.next = 325;
                                        break;
                                      }

                                      groupId = _step9.value;

                                      if (user.groupName) {
                                        user.groupName += " | ";
                                      }
                                      _context2.next = 321;
                                      return GroupsService.getNameById(groupId);

                                    case 321:
                                      user.groupName += _context2.sent;

                                    case 322:
                                      _iteratorNormalCompletion9 = true;
                                      _context2.next = 316;
                                      break;

                                    case 325:
                                      _context2.next = 331;
                                      break;

                                    case 327:
                                      _context2.prev = 327;
                                      _context2.t22 = _context2["catch"](314);
                                      _didIteratorError9 = true;
                                      _iteratorError9 = _context2.t22;

                                    case 331:
                                      _context2.prev = 331;
                                      _context2.prev = 332;

                                      if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                        _iterator9.return();
                                      }

                                    case 334:
                                      _context2.prev = 334;

                                      if (!_didIteratorError9) {
                                        _context2.next = 337;
                                        break;
                                      }

                                      throw _iteratorError9;

                                    case 337:
                                      return _context2.finish(334);

                                    case 338:
                                      return _context2.finish(331);

                                    case 339:
                                      _context2.next = 342;
                                      break;

                                    case 341:
                                      user.groupName = "N.C.";

                                    case 342:

                                      if (user.positions) {
                                        user.positions = user.positions.filter(function (item) {
                                          if (item === $rootScope.rhManagerValue && $rootScope.rhManagerHidden) {
                                            return false;
                                          } else if (item === $rootScope.qseManagerValue && $rootScope.qseManagerHidden) {
                                            return false;
                                          } else if (item === $rootScope.fleetManagerValue && $rootScope.fleetManagerHidden) {
                                            return false;
                                          } else if (item === $rootScope.other1ManagerValue && $rootScope.other1ManagerHidden) {
                                            return false;
                                          } else if (item === $rootScope.other2ManagerValue && $rootScope.other2ManagerHidden) {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }).map(function (item) {
                                          if (item === $rootScope.defaultManagerValue) {
                                            item = $rootScope.defaultManagerLabel;
                                          } else if (item === $rootScope.rhManagerValue) {
                                            item = $rootScope.rhManagerLabel;
                                          } else if (item === $rootScope.qseManagerValue) {
                                            item = $rootScope.qseManagerLabel;
                                          } else if (item === $rootScope.fleetManagerValue) {
                                            item = $rootScope.fleetManagerLabel;
                                          } else if (item === $rootScope.other1ManagerValue) {
                                            item = $rootScope.other1ManagerLabel;
                                          } else if (item === $rootScope.other2ManagerValue) {
                                            item = $rootScope.other2ManagerLabel;
                                          }
                                          return item;
                                        });
                                      }

                                      vm.rawData.push(user);
                                      if (user.active && !user.onlyCommuteTrips) {
                                        vm.rawActive.push(user);
                                      }
                                      if (user.duplicate) {
                                        vm.rawDuplicate.push(user);
                                      }
                                      if (user.toCheck && !user.onlyCommuteTrips) {
                                        vm.rawToCheck.push(user);
                                      }

                                      if (user.onlyCommuteTrips) {
                                        vm.rawCommute.push(user);
                                      }

                                    case 348:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _loop, _this, [[6, 34, 38, 46], [13, 17, 21, 29], [22,, 24, 28], [39,, 41, 45], [79, 107, 111, 119], [86, 90, 94, 102], [95,, 97, 101], [112,, 114, 118], [143, 148, 152, 160], [153,, 155, 159], [261, 274, 278, 286], [279,, 281, 285], [314, 327, 331, 339], [332,, 334, 338]]);
                            });
                            index = 0;

                          case 85:
                            if (!(index < users.length)) {
                              _context3.next = 90;
                              break;
                            }

                            return _context3.delegateYield(_loop(), "t3", 87);

                          case 87:
                            index++;
                            _context3.next = 85;
                            break;

                          case 90:

                            vm.needToBeUpdate = true;

                            $scope.$apply();
                            Notiflix.Loading.remove();

                          case 93:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee2, _this, [[6, 36, 40, 48], [15, 19, 23, 31], [24,, 26, 30], [41,, 43, 47], [67, 71, 75, 83], [76,, 78, 82]]);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 26:
                _context4.next = 32;
                break;

              case 28:
                _context4.prev = 28;
                _context4.t0 = _context4["catch"](15);

                console.error(_context4.t0);
                Notiflix.Loading.remove();

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, _this, [[15, 28]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.executeAction = function () {
      console.log("action=", vm.action);

      $confirm({
        text: "Etes vous certain d'appliquer l'action " + vm.action + " sur les lignes sélectionnées?"
      }).then(function () {
        console.log("oui il veut", vm.rawData);

        for (var index = 0; index < vm.rawData.length; index++) {
          if (vm.rawData[index].checkbox) {
            console.log("s=", vm.rawData[index]);
            UsersService.deleteById(vm.rawData[index]._id).then(function () {});
          }
        }
      });

      vm.action = "Actions sur sélection";
    };

    vm.gridEvent = function (value) {
      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      } else if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 5;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Collaborateurs"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.deleteFilter = function () {
      delete vm.customerId;
      vm.refresh();
    };

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isLvr = ["super-admin", "super-operator", "operator"].indexOf($rootScope.$user.role) > -1;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var writeResource = vm.isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.resource && $rootScope.$user.rights.resource.write && $rootScope.$user.rights.resource.write === true;
    var deleteResource = vm.isAdmin || $rootScope.$user.rights && $rootScope.$user.rights.resource && $rootScope.$user.rights.resource.delete && $rootScope.$user.rights.resource.delete === true;

    if (writeResource !== true) {
      vm.create = null;
      vm.edit = null;
    }

    vm.delete = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var deleteUser;
        return regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return swal({
                  title: "Voulez-vous supprimer le collaborateur " + row.lastName + " " + row.firstName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteUser = _context5.sent;

                if (!deleteUser) {
                  _context5.next = 7;
                  break;
                }

                console.log("need to delete this user", row);
                _context5.next = 7;
                return UsersService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    vm.setGridColumns = function () {
      var managerFields = [AgGridService.text("managerName", vm.defaultManagerLabel), AgGridService.bool("defaultManagerIdIsAutoFilled", "Rempli automatiquement", 100, { columnGroupShow: "open" })];

      if (!$rootScope.rhManagerHidden) {
        managerFields.push(AgGridService.text("rhManagerName", vm.rhManagerLabel));
        managerFields.push(AgGridService.bool("rhManagerIdIsAutoFilled", "Rempli automatiquement", 100, {
          columnGroupShow: "open"
        }));
      }

      if (!$rootScope.qseManagerHidden) {
        managerFields.push(AgGridService.text("qseManagerName", vm.qseManagerLabel));
        managerFields.push(AgGridService.bool("qseManagerIdIsAutoFilled", "Rempli automatiquement", 100, {
          columnGroupShow: "open"
        }));
      }

      if (!$rootScope.fleetManagerHidden) {
        managerFields.push(AgGridService.text("fleetManagerName", vm.fleetManagerLabel));
        managerFields.push(AgGridService.bool("fleetManagerIdIsAutoFilled", "Rempli automatiquement", 100, { columnGroupShow: "open" }));
      }
      if (!$rootScope.other1ManagerHidden) {
        managerFields.push(AgGridService.text("other1ManagerName", vm.other1ManagerLabel));
        managerFields.push(AgGridService.bool("other1ManagerIdIsAutoFilled", "Rempli automatiquement", 100, { columnGroupShow: "open" }));
      }
      if (!$rootScope.other2ManagerHidden) {
        managerFields.push(AgGridService.text("other2ManagerName", vm.other2ManagerLabel));
        managerFields.push(AgGridService.bool("other2ManagerIdIsAutoFilled", "Rempli automatiquement", 100, { columnGroupShow: "open" }));
      }

      //--- TABS 1 ---//
      vm.columnDefs = [AgGridService.text("lastName", "Nom", 200, { pinned: "left" }), AgGridService.text("firstName", "Prénom", 200, { pinned: "left" }), AgGridService.text("groupName", "Groupes")];

      if (vm.syncConfig && vm.syncConfig.software) {
        vm.columnDefs.push(AgGridService.text("internalNumber", "ID " + vm.syncConfig.software));
        vm.columnDefs.push(AgGridService.text("trueInternalNumber", "Matricule"));
      } else {
        vm.columnDefs.push(AgGridService.text("internalNumber", "Matricule"));
      }

      vm.columnDefs = [].concat(_toConsumableArray(vm.columnDefs), [AgGridService.bool("toCheck", "À vérifier"), AgGridService.bool("active", "Actif"), AgGridService.text("positionTitle", "Titre"), AgGridService.text("contractName", "Contrat"), AgGridService.text("externalCompany", "Société d'intérim"), AgGridService.text("email", "Email"), AgGridService.text("phone", "Téléphone"), AgGridService.text("cellularPhone", "Portable"), AgGridService.text("positions", "Fonctions"), AgGridService.text("vehicleNames", "Véhicules affectés"), AgGridService.text("typeVehicleNames", "Types de véhicules conduits"), AgGridService.group("Responsables", managerFields), AgGridService.text("usersEmailCc", "Collaborateurs en copie"), AgGridService.text("areaName", "Zone de travail"), AgGridService.text("departmentName", "Département"), AgGridService.date("licenceValidityDate", "Date de validité du permis"), AgGridService.text("shortElearning", "Vidéos (12 derniers mois)"), AgGridService.text("longElearning", "E-learning vidéos"), AgGridService.bool("isMulti", "Multi-accidenté"), AgGridService.group("Sinistres (dernier 12 mois)", [AgGridService.date("lastDamageDate", "Dernier sinistre", 110, null), AgGridService.number("nbDamages", "Nb Sinistres", 100, {
        columnGroupShow: "open"
      }), AgGridService.number("nbDispute100", "Resp 100%", 100, {
        columnGroupShow: "open"
      }), AgGridService.number("nbDispute50", "Resp 50%", 100, {
        columnGroupShow: "open"
      }), AgGridService.number("nbDispute0", "Resp 0%", 100, {
        columnGroupShow: "open"
      }), AgGridService.number("nbAccidents", "Nb Accidents", 100, {
        columnGroupShow: "open"
      })]), AgGridService.group("DEPAs (dernier 12 mois)", [AgGridService.date("lastDepaDate", "Dernier DEPA", 110, null), AgGridService.number("nbDepas", "Nb DEPA effectués", 100, {
        columnGroupShow: "open"
      }), AgGridService.number("nbMissingDepas", "Nb RDV manqués (sur 12 mois)", 100, {
        columnGroupShow: "open"
      })]), AgGridService.group("Formations", [AgGridService.date("lastCourseDate", "Dernière Formation", 110, null), AgGridService.number("nbCourses", "Nb Formations", 100, {
        columnGroupShow: "open"
      })])]);

      if (vm.softwareName) {
        var telematicsColumns = [];
        var keyMap = {
          globalScore: "Note générale"
        };
        var _arr = ["globalScore"];
        for (var _i = 0; _i < _arr.length; _i++) {
          var key = _arr[_i];
          for (var month = 0; month < 4; month++) {
            var keyFormat = moment().subtract(month, "month").format("-YY-MM");
            var longFormat = moment().subtract(month, "month").format("MMMM YY");
            // telematicsColumns.unshift(AgGridService.number(`${key}Telematic${keyFormat}`, `${keyMap[key]} (sur 10) ${longFormat}`, 100));
            telematicsColumns.unshift(AgGridService.number(key + "Telematic" + keyFormat, "" + longFormat, 75));
          }
        }

        vm.columnDefs.push(AgGridService.group(vm.softwareName, telematicsColumns));
      }

      vm.columnDefs = [].concat(_toConsumableArray(vm.columnDefs), [AgGridService.number("yearOfBirth", "Année de naissance"), AgGridService.date("startDate", "Date d'embauche"), AgGridService.date("endDate", "Date de sortie"), AgGridService.date("endBlockDate", "Date de fin d'arrêt"), AgGridService.date("creationDate", "Date de création"), AgGridService.date("lastUserModificationDate", "Date de modification")]);

      if (vm.isLvr) {
        vm.columnDefs = [].concat(_toConsumableArray(vm.columnDefs), [AgGridService.date("importDate", "Date d'import"), AgGridService.text("importByName", "Importé par"), AgGridService.date("updateDate", "Mis à jour le"), AgGridService.text("updateByName", "Mis à jour par"), AgGridService.bool("isVisibleByEveryone", "Collaborateur visible par tout le monde", 100), AgGridService.bool("isVirtual", "Collaborateur virtuel", 100), AgGridService.bool("canLoginToBeta", "Droits de se connecter à la bêta", 100)]);
      }

      vm.columnDefs.unshift(AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this, {
        width: 110
      }));

      if (writeResource || deleteResource) {
        var adminColumns = [];

        if (writeResource) {
          adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, _this, {
            width: 90
          }));
        }
        if (deleteResource && writeResource) {
          adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this, {
            width: 90,
            columnGroupShow: "open"
          }));
        } else if (deleteResource) {
          adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this, {
            width: 90
          }));
        }
        var adminGroup = AgGridService.group("Admin", adminColumns);
        vm.columnDefs.unshift(adminGroup);
      }

      if (["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false) {
        vm.columnDefs.unshift(AgGridService.checkbox());

        vm.columnDefs.push(AgGridService.text("roleName", "Privilège", 100));

        vm.columnDefs.push(AgGridService.group("Sinistre", [AgGridService.text("rightsDamageRead", "Lecture", 100), AgGridService.text("rightsDamageWrite", "Écriture", 100, {
          columnGroupShow: "open"
        }), AgGridService.text("rightsDamageSend", "Transmission", 100, {
          columnGroupShow: "open"
        }), AgGridService.text("rightsDamageDelete", "Suppression", 100, {
          columnGroupShow: "open"
        })]));

        vm.columnDefs.push(AgGridService.group("DEPA", [AgGridService.text("rightsDepaRead", "Lecture", 100), AgGridService.text("rightsDepaWrite", "Écriture", 100, {
          columnGroupShow: "open"
        })]));

        vm.columnDefs.push(AgGridService.group("Formation", [AgGridService.text("rightsCourseRead", "Lecture", 100), AgGridService.text("rightsCourseWrite", "Écriture", 100, {
          columnGroupShow: "open"
        }), AgGridService.text("rightsCourseDelete", "Suppression", 100, {
          columnGroupShow: "open"
        })]));

        vm.columnDefs.push(AgGridService.group("Collaborateurs/Véhicules", [AgGridService.text("rightsResourceRead", "Lecture", 100), AgGridService.text("rightsResourceWrite", "Écriture", 100, {
          columnGroupShow: "open"
        }), AgGridService.text("rightsResourceDelete", "Suppression", 100, {
          columnGroupShow: "open"
        })]));
      }
    };

    vm.refresh();
  }
})();